/*
 * @Description: 常量
 * @Date: 2024-11-07 15:21:16
 */
/**
 * 验证结果页面类型：entAuth企业认证中，entFail企业认证失败，userAuth联系人认证中，userFail联系人认证失败, skip跳过实名
 */
export enum ResultPageTypeEnum {
  ENT_AUTH = 'entAuth',
  ENT_FAIL = 'entFail',
  USER_AUTH = 'userAuth',
  USER_FAIL = 'userFail',
  SKIP = 'skip'
}

/**
 * 主体类型:1:工业2:服务商3:供应商8:代办供应商
 */
export enum entpTypeEnum {
  GY = 1,
  FWS = 2,
  GYS = 3,
  DBGYS = 8
}

/**
 * 企业信息表单字段 key
 */
export enum EnterpriseEnum {
  /**
   * 企业名称
   */
  entpName = 'entpName',
  /**
   *  营业执照URL
   */
  entpCertPic = 'entpCertPic',
  /**
   * 企业证件编码类型
   */
  entpCertType = 'entpCertType',
  /**
   * 企业证件号
   */
  entpCertNo = 'entpCertNo',
  /**
   * 法人姓名
   */
  legalName = 'legalName',
  /**
   * 联系人姓名
   */
  contactor = 'contactor',
  /**
   * 联系人身份证号
   */
  contactId = 'contactId',
  /**
   * 联系人手机号
   */
  contactorPhone = 'contactorPhone',
  /**
   * 主体 1 工业 2 服务商  3 供应商
   */
  entityType = 'entityType',
  /**
   * 是否跳过实名 0 否 1 是
   */
  isSkip = 'isSkip'
}

/**
 * 企业证件编码类型：1统一社会信用码，2工商注册号
 */
export enum EntpCertTypeRnum {
  ONE = 1,
  TWO = 2
}

/**
 * 1 勾选 确认提交，
 * 2 注册企业信息 - 前往认证，
 * 8 完成实名认证待平台审核，
 * 10 审核失败页面 重新回到第一步
 * 11 审核通过
 */
export enum AuthStepEnum {
  ONE = 1,
  TWO = 2,
  EIGHT = 8,
  TEN = 10,
  ELEVEN = 11
}

/**
 * 1 勾选 确认提交，
 * 2 注册企业信息 - 前往认证，
 * 8 完成实名认证待平台审核，
 * 10 审核失败页面 重新回到第一步
 * 11 审核通过
 */
export const AuthStepMapping = {
  [AuthStepEnum.ONE]: {
    name: 'enterprise-real-agreement',
    query: {},
    des: '勾选协议'
  },
  [AuthStepEnum.TWO]: {
    name: 'enterprise-real-index',
    query: {},
    des: '注册企业信息'
  },
  [AuthStepEnum.EIGHT]: {
    name: 'enterprise-real-result',
    query: {
      pageType: ResultPageTypeEnum.ENT_AUTH
    },
    des: '完成实名认证待平台审核'
  },
  [AuthStepEnum.TEN]: {
    name: 'enterprise-real-result',
    query: {
      pageType: ResultPageTypeEnum.ENT_FAIL
    },
    des: '审核失败页面'
  }
};
